let jsc = require('js-clipper');
let merge = require("merge")

/*
NOTE: Some of the details in this description might be deprecated, 
but the overall picture should be correct.

All input to the libary should be in mm/10 which is also the smallest unit
that decide the accuracy of the solution. Thus a distence of 2 cm should be
given as 200 in the input coordiates.

Usage example (description follows after):
  let roof = [
		[{X:0,Y:0},...],
		...
	]
	let plate = {
		width: 1500,
		height: 700,
		horizontalOffset: 35,
		verticalOffset: 35,
		rotate: false,
	}

	let lay = new Layout()
	lay.setPlate(plate)
	let layout = lay.layout(roof)

	// layout is now an object looking like this:
	layout = {
		noPlates: 142,	 // The minimum number of plates needed
		noPieces: 177,   // The total  number of pieces (including cut ones) placed
		layout: [
			// For each roof patch do a description on the layout
			{
				pieces: [
					{
						plate: 3,	// Id of the plate from which this piece was cut
            patch: 0, // Index of the patch at which this one is placed
						outline: [{X:...},...], // Shape of the piece in piece-local coordinates
						cutPosition: {X:0, Y:0}, // the position in the plate the piece is coming from
						patchPosition: {X:111, Y:43}, // The position in the  patch this piece should be placed
            cut: true|false // If it is a complete plate or not
					},
					...
				]
			}
		]
	}
*/

let jscAreaAbs = function(poly){
    return Math.abs(jsc.Clipper.Area(poly));
}

export default class Layout {
  constructor() {
		let plate = {
			width: 10000,
			height: 10000,
			horizontalOffset: 1000,
			verticalOffset: 1000,
			rotate: false,
		}
		this.plate = plate;
  }

  // For description see the introduction above
  layout(roof) {
    // a roof consists of multiple patches - for now we simply optimize each one
    // individually...

    let sol = [];

    for(let i = 0; i < roof.length; i++) {
      let patch = roof[i];
      let startP = this.findstarts(patch)

      if(startP.length > 1)
        throw "multiple starting positions have not been implemented! The cost below is not sufficient as it must also include the no plates"

      // Only use the best starting position for this patch
      let c = 1e300
      let r = {};
      for(let j = 0;  j < startP.length; j++) {
        let res = this.placePatch(startP[j], patch)
        let cost = this.cost(res)
        if(cost > c)
          continue
        c = cost
        r = res
      }

      r.cost = c;
      sol.push(r)
    }

    // So we now want to collect all the "individual" patch information in the
    // patches to a complete one for the entire roof.
    let layout = {
			area: 0,
      noPlates: 0,
      noPieces: 0,
      plates: [],
      pieces: [],
    }

		// create the area by suming up the patches
		for(let i = 0; i < roof.length; i++) {
			let patch = roof[i]
		    layout.area += jscAreaAbs(patch)
		}

    // Keep track of the plate numbers (this will have to change when we optimize layout)
    let plateno = 0;
    for(let i = 0; i < sol.length; i++) {
      let r = sol[i]
      layout.noPlates += r.no
      layout.noPieces += r.no

      for(let j = 0; j < r.pieces.length; j++) {
        let p = r.pieces[j].piece
        let pl = r.pieces[j].plate

        let piece = {
          plate: plateno,
          patch: i,
          cutPosition: {X:0, Y:0},
          patchPosition: {X:p[0].X, Y:p[0].Y},
					platePosition:{},
					plateTransf: {X:p[0].X-r.pieces[j].plate[0].X, Y:p[0].Y-r.pieces[j].plate[0].Y},
          cut: jscAreaAbs(p) != (this.plate.width*this.plate.height),
        }
        piece.outline = this.sub(p, p[0])
        layout.pieces.push(piece)
        // Add a plate item so we can know the size of the plate used
        layout.plates.push({
          height:r.pieces[j].height,
          outline: pl,
        })

        plateno++;
      }
    }

  // NOTE: IT MUST NOW ALSO UPDATE THE PLATE ARRAY - NOT JUST THE NUMBERS?
		let res = this.cutPieces(layout);
		if (res.error){
			throw "Error when cutting pieces: " + res.error;
		}
		layout.noPlates = res.no;

		//console.log(layout.noPlates,layout.plates.length,layout.pieces.length);
		let max = 0;
		for(let i = 0; i < layout.pieces.length; i++){
			if (layout.pieces[i].plate > max) max = layout.pieces[i].plate
		}
		//console.log("max plate no: ", max)

    return layout;
  }

  // Subtract the position from the polygon - i.e. translate it
  // Note that it modifies the original
  sub(poly, off) {
    let x = off.X, y = off.Y;
    for(let i = 0; i< poly.length; i++) {
      poly[i].X -= x
      poly[i].Y -= y
    }
    return poly
  }

  findstarts(patch) {
    // For now we only suggest a few deterministic starting positions, long term
    // this  could be used to further optimize
    let pos = {X:0, Y:0}
    let minX = 1e300,
        maxX = -1e300,
        minY = 1e300,
        maxY = -1e300;

    for(let i = 0; i < patch.length; i++) {
      let p = patch[i];
      if(p.X < minX)
        minX = p.X
      if(p.X > maxX)
        maxX = p.X
      if(p.Y < minY)
        minY = p.Y
      if(p.Y > maxY)
        maxY = p.Y
    }

    let dX = maxX-minX,
        dY = maxY-minY;

    // If the overlap is larger than 1/10 of a plate we put it on one side - else
    // we split it equaly for balance.
    let cv = this.plate.width-this.plate.horizontalOffset
    // TODO(viktor): Fix this logic such that he makes reasonable choices.
    if((dX%cv)==0) {
      pos.X = minX
    } else if((dX%cv)<cv/2) {
      pos.X = minX - (cv+(dX%cv))/2
    } else {
      pos.X = minX - (cv+(dX%cv))/2
    }
    // This is intentionally hard-coded since it seems as if the plates have a
    // speciall edge downwards
    pos.Y = minY

    return [pos]
  }

	setPlate(p) {
		this.plate = merge(this.plate, p)
	}

	// Assumes the polygon is a simple array of points {X,Y}
	copyPolygon(p){
		let pn = [];
		for (let i = 0; i < p.length; p++ ){
			pn.push({X:p[i].X,Y:p[i].Y});
		}
		return pn;
	}

	// Adds translation to each element of array
	add(outline, trans){
		let ol2 = [];
		for (let l = 0; l < outline.length; l++){
			let point = outline[l];
			ol2.push({X:point.X+trans.X,Y:point.Y+trans.Y})
		}
		return ol2;
	}

	// Reduce plate numbers to minimal range, modifies in place, also modified the class (plates)
	// Note:assumes merged plates are always merged to their lowest plate number
	trimPlateNumbers(layout){
		let pieces = layout.pieces;
		// Simple approach
		// Loop through all pieces to find plates number missing
		let plateExist = [];
		for (let i = 0; i < pieces.length; i++){
			plateExist[i] = false;
		}

		for (let i = 0; i < pieces.length; i++){
			plateExist[pieces[i].plate] = true;
		}

		// Remove plates and make cumulative count of missing plates
		let cum = [];
		cum.push(0);
		let newPlates = [];
		for (let i = 0; i < plateExist.length; i++){
			let prev = cum[i];
			if (plateExist[i]){
				cum.push(prev);
				newPlates.push(layout.plates[i]);
			}else{
				cum.push(prev+1);
			}
		}
		// Re-set the plates to the compressed list
		layout.plates = newPlates;
		// Subtract the cumulative count from the pieces plate number
		for (let i = 0; i < pieces.length; i++){
			pieces[i].plate -= cum[pieces[i].plate];
		}

		layout.noPlates = newPlates.length;
		return newPlates.length;
	}


	fitsInPlate(pieceOL, plateOL){
		this.order(pieceOL);
		this.order(plateOL);

		let solution = new jsc.Paths();
		var c = new jsc.Clipper();
		c.AddPaths([plateOL], jsc.PolyType.ptSubject, true);
		c.AddPaths([pieceOL], jsc.PolyType.ptClip, true);
		c.Execute(jsc.ClipType.ctIntersection, solution);
		if(solution.length <= 0) {
			return false;
		}
		this.order(solution[0]);		

		return this.piecesEqual(solution[0], pieceOL);
	}

	// Given an array of pieces that should be cut from plates return a description
	// of how they may "optimally" be cut from the plates in order to minimize the
	// number of plates needed.
	// cutmode species allowed cuts, available are: "V", "H", "D", "ALL","VHD"
	cutPieces(layout) {
		let pieces = layout.pieces;
		let plates = layout.plates;
		// Create slimmed copy of pieces to modify
		let piecesSlimmed = [];

		for (let i = 0; i < pieces.length; i++){
			let piece = pieces[i];
			if (piece.cut){
				piecesSlimmed.push({
					origIndex: i, // Mapping to original index
					plate: piece.plate,
					plateTransf:piece.plateTransf,
					outline: piece.outline,
					cutPosition: {X:0, Y:0},
				});
			}
		}
		
		piecesSlimmed.sort(function(p1,p2){
			let a1 = jscAreaAbs(p1.outline)+0;
			let a2 = jscAreaAbs(p2.outline)+0;
			if (a1 == a2){
				return 0;
			}
			let ret = a1 > a2
			return ret?-1:1;			
		})

		// Find possibly combined plates
		for (let i = 0; i < piecesSlimmed.length; i++){
			let piece = piecesSlimmed[i];
			let a1 = jscAreaAbs(piece.outline);

			if (piece.visited == true){
				continue;
			}
			piece.visited = true;

			let piecesInPlate = [piece];
			for (let j = i+1; j < piecesSlimmed.length; j++){
				let piece2 = piecesSlimmed[j];
				if (piece2.visited == true){
					continue;
				}

				// transform piece outline to plate coordinates
				let ol2 = this.add(piece2.outline,piece2.plateTransf);

				// Check that we fit within the plate
				let plate;
				let plateNo ;
				let plateQuery = this.sub(plates[piece.plate].outline, plates[piece.plate].outline[0]);
				if (this.fitsInPlate(ol2,plateQuery)){
					plateNo = piece.plate
				}else if(piecesInPlate.length == 1){
					// Can be in second plate only if no merges exists
					let olk = this.add(piecesInPlate[0].outline, piecesInPlate[0].plateTransf);
					if (this.fitsInPlate(olk, plateQuery)){
						plateNo = piece2.plate;
					}else{
						continue;
					}
				}else{
					continue;
				}

				let intersected = false;
				// intersect against each piece allready in plate
				for (let k = 0; k < piecesInPlate.length; k++){
					let olk = this.add(piecesInPlate[k].outline, piecesInPlate[k].plateTransf);

					let solution = new jsc.Paths();
					var c = new jsc.Clipper();
					c.AddPaths([olk], jsc.PolyType.ptSubject, true);
					c.AddPaths([ol2], jsc.PolyType.ptClip, true);
					c.Execute(jsc.ClipType.ctIntersection, solution);
					if(solution.length > 0) {
						intersected = true;
						break; // Intersection, cant merge
					}
				}
				if (!intersected){
					piece2.visited = true;
					piece2.plate = plateNo;
					if (plateNo !== piece.plate){
						for (let k = 0; k < piecesInPlate.length; k++){
							piecesInPlate[k].plate = plateNo;
						}
					}
					piecesInPlate.push(piece2);
				}
			}
		}

		// Re-set plate number in original array
		for (let i = 0; i<piecesSlimmed.length; i++){
			let pieceMod = piecesSlimmed[i];
			let piece = pieces[pieceMod.origIndex];
			piece.plate = pieceMod.plate;
			piece.cutPosition = pieceMod.cutPosition;
		}
		//let noPlates = -1;
		let noPlates = this.trimPlateNumbers(layout);
		let result = {
			error: undefined,
			no: noPlates,			// Number of plates needed
		}
		return result;
	}

  // Returns the cost of a particular solution from place Patch to allow us to
  // optimize - very simple for now.
  cost(res) {
    return res.no + res.noCut/100
  }

	// Given a patch and a starting position produce a list of where pieces should
	// be placed and if they need cutting their shape
	placePatch(start, patch) {
		// Try the full rectangle of placements given by the bounds of the patch,
		// making a rectangular grid and storing all the ones which are inside.
		let result = {
			area: 0.0, // Area of added plates including offset (i.e. not equal to patch area)
			areaCut: 0.0, // Area of added cut plates
			areaUncut: 0.0, // Area of added uncut plates
			no: 0,
			noCut: 0,
			noUncut: 0,
			pieces: [],
			piecesCut: [],
			piecesUncut: [],
		};


		let bnd = jsc.Clipper.GetBounds([patch])
    // Calculate the starting positions
    let xs = bnd.left-(this.plate.width-this.plate.horizontalOffset)+Math.abs( (bnd.left-start.X) % (this.plate.width-this.plate.horizontalOffset));
    // The algorithm is dependent on starting position being at the bottom.
    let ys = start.Y
    let height = this.plate.height
    if(this.plate.height.type=="variable") {
      height = this.plate.height.max
    } else if(this.plate.height.type=="stepwise") {
      height = this.plate.height.height[this.plate.height.height.length-1]
		}
		
		for(let y = ys; y < bnd.bottom-1*this.plate.verticalOffset; 
			y += height - this.plate.verticalOffset)
		{
			for(let x = xs; x < bnd.right-1*this.plate.horizontalOffset; 
				x += this.plate.width-this.plate.horizontalOffset)
			{
				let pi = this.createPiece(x, y, height)
        pi.height = height
				let solution = new jsc.Paths();
				var c = new jsc.Clipper();
				c.AddPaths(pi, jsc.PolyType.ptSubject, true);
				c.AddPaths([patch], jsc.PolyType.ptClip, true);
				c.Execute(jsc.ClipType.ctIntersection, solution);

				if(solution.length == 0 ||
					x <=  bnd.left - (this.plate.width-this.plate.horizontalOffset) ||
					y <= bnd.top - (height-this.plate.verticalOffset)
					) {
					continue // No intersection, placement fully outside the patch
				}

        // Now, if the height is variable we should limit the plate
        // size to what we need - no need to use a longer one than
        // we need.
        if(this.plate.height.type == "variable") {
            let bnds = jsc.Clipper.GetBounds(solution);
            let h = bnds.bottom-bnds.top;
            if(h < this.plate.height.min) {
              h = this.plate.height.min
            }
            pi = this.createPiece(x, y, h)
            pi.height = h;
        } else if(this.plate.height.type == "stepwise") {
            let bnds = jsc.Clipper.GetBounds(solution);
            let h = bnds.bottom-bnds.top;
            for( let i = 0; i < this.plate.height.height.length; i++) {
              if(h <= this.plate.height.height[i]) {
                h = this.plate.height.height[i]
                break;
              }
            }
          pi = this.createPiece(x, y, h)
          pi.height = h;
        }
				// Sort the pieces such that we can compare them, todo is to see if we
				// can avoid this overhead.

				this.order(solution[0])
				this.order(pi[0])

				let area = jscAreaAbs(solution[0]);
				result.area += area;
				result.no++;
				result.pieces.push({piece:solution[0],plate:pi[0], height: pi.height});
        // TODO: could this check be made simpler and faster using just area?
				if(this.piecesEqual(solution[0], pi[0])) {
				  result.piecesUncut.push(solution[0])
					result.areaUncut += area
					result.noUncut++;
					continue
				}
				result.areaCut += area;
				result.noCut++;
				result.piecesCut.push({piece:solution[0],plate:pi[0]});
			}
		}
		return result
	}

	piecesEqual(a, b) {
		if(a.length != b.length)
			return false
		for(let i = 0; i < a.length; i++) {
			if(a[i].X != b[i].X || a[i].Y != b[i].Y)
				return false
		}
		return true
	}

	createPiece(x,y, height) {
		return [[
			{X:x, Y:y},
			{X:x+this.plate.width, Y:y},
			{X:x+this.plate.width, Y:y+height},
			{X:x, Y:y+height},
		]]
	}

	order(p) {
		// Find the minimum position and rotate the array
		let eps = 1e-8
		let j = 0;
		for(let i = 1; i < p.length; i++) {
			if(((p[i].X - p[j].X) < - eps) || (Math.abs(p[i].X - p[j].X) < eps && p[i].Y - p[j].Y < eps)) {
//				if((p[i].X < p[j].X) || (p[i].X == p[j].X && p[i].Y < p[j].Y)) {
				j = i
			}
		}
		
		this.rotate(p, p.length-j)
		//this.rotate(p, j-1)
	}

	reverse(arr, left, right) {
	    while (left < right) {
	        var temp = arr[left];
	        arr[left] = arr[right];
	        arr[right] = temp;
	        left++;
	        right--;
	    }
	    return arr;
	}

	rotate(arr, k) {
		
      if(k<0)
        return arr
	    var l = arr.length;
	    arr = this.reverse(arr, 0, l - 1);
	    arr = this.reverse(arr, 0, k - 1);
	    arr = this.reverse(arr, k, l - 1);
	    return arr;
	}

  test(a) {
    if (a > 2) {
      return 3
    }
    return 1;
  }

	findMinMax(coordsArr){
		let maxX = -1e6,minX=1e6,maxY=-1e6,minY=1e6;
		for (let k = 0; k < coordsArr.length; k++){
			let x = coordsArr[k].X;
			let y = coordsArr[k].Y;
			if (x < minX) minX = x;
			if (x > maxX) maxX = x;
			if (y < minY) minY = y;
			if (y > maxY) maxY = y;
		}
		return {min:{X:minX,Y:minY},max:{X:maxX,Y:maxY}};
	}

	//////////////// For use with the advanced piece cutting algorithm ///////

	// Aligns vertices of two polygons, the second polygon is the one translated in the return
	// Does not modify inputs
	align(p1,index1,p2,index2){

		let pAligned = this.copyPolygon(p2);
		// Find translation between points
		let trans = {
				X:p1[index1].X-p2[index2].X,
				Y:p1[index1].Y-p2[index2].Y,
			};
		// Translate second polygon according to translation
		for (let i = 0; i < pAligned.length; i++){
			pAligned[i].X += trans.X;
			pAligned[i].Y += trans.Y;
		}
		return pAligned;
	}

	// Tries to fit the piece within the plate
	// Note modifies the piece and sharedPlate upon success
	// NOTE: Also modifies the pieces outline
	// Returns true if successful
	fitPiece(sharedPlate, piece){
		if (jscAreaAbs(piece) > jscAreaAbs(sharedPlate.unusedPoly)){
			return false;
		}

		let plate = sharedPlate.unusedPoly;
		//let p2 = piece.outline;
		let p2 = this.copyPolygon(piece.outline);

		// Naively try to align vertices by brute force until fit is found
		// TODO: can be made smarter
		// Potential references could be
		// https://www.researchgate.net/publication/223843281_or
		// http://www.kurims.kyoto-u.ac.jp/~kyodo/kokyuroku/contents/pdf/0872-04.pdf
		for (let i = 0; i < plate.length; i++){
			for (let j = 0; j < p2.length; j++){
				p2 = this.align(plate, i, p2, j);
				// Clip polygons and see if a fit is found
				let solution = new jsc.Paths();
				var c = new jsc.Clipper();
				c.AddPaths([p2], jsc.PolyType.ptSubject, true);
				c.AddPaths([plate], jsc.PolyType.ptClip, true);
				c.Execute(jsc.ClipType.ctIntersection, solution);
				if(solution.length == 0) {
					continue // No intersection, placement fully outside the patch
				}

				let isFit = jscAreaAbs(solution[0]) == jscAreaAbs(p2);


				let area = jscAreaAbs(solution[0]);
				result.area += area;
				result.no++;
				result.pieces.push(solution[0])
        // TODO: could this check be made simpler and faster using just area?
				if(this.piecesEqual(solution[0], pi[0])) {
				  result.piecesUncut.push(solution[0])
					result.areaUncut += area
					result.noUncut++;
					continue
				}

				if (isFit){
					// Update outline to be position in plate local coordinates
					piece.outline = p2;

					// Cut is simply edges not being shared between polygons
					piece.cutPosition = findComplementEdges(solution[0],plate);

					sharedPlate.pieces.push(piece);
					sharedPlate.unusedPoly = {} // TODO: take from js clipper
					return true;
				}
			}
		}
	}

	// Finds Edges(p1)\Edges(p2), assumes p1 and p2 are ordered counter clockwise
	//TODO:Not tested
	findComplementEdges(p1,p2){
		// Find a shared vertex
		let offset = -1;
		for (let i = 0; i < p2.length; i++){
			if (p1[0].X == p2[i].X && p1[0].Y == p2[i].Y){
				offset = i;
				break;
			}
		}
		if (offset < 0){
			throw "No shared edges found, even though its supposed to";
		}

		function geti2(i){
			return i+offset <= p2.length ? (i+offset) : ((i+offset)%p2.length);
		}
		function calcSlope(p1,p2){
			(p2.Y-p1.Y)/(p2.X-p1.X);
		}

		let curves = [];
		let cutCount = 0;
		let count2 = 1;
		for (let i = count2; i < p1.length; i++){
			let i2 = geti2(count2);
			if ( !(p1[i].X == p2[i2].X && p1[i].Y == p2[i2].Y) ){
				// The curve for this cut
				let curve = [];
				// Does the edge still coincide?
				let s2 = calcSlope(p2[i2],p2[geti2(i-1)]);
				let s1 = calcSlope(p1[i],p1[i-1]);
				if (s1 != s2){
					curve.push({X:p2[geti2(i-1)].X,Y:p2[geti2(i-1)].Y});
				}
				curve.push({X:p2[i2].X,Y:p2[i2].Y});

				let count2 = i+1;
				// Naive double loop to check when we align again
				let converged = false;
				while(geti2(count2) != offset){
					// Naive check for conciding again
					for (let j = i + 1; j < p1.length; j++){
						if (p1[j].X == p2[geti2(count2)].X && p1[j].Y == p2[geti2(count2)].Y){
							converged = true;
							// Should we include this point?
							let s2 = calcSlope(p2[geti2(count2)],p2[geti2(count2-1)]);
							let s1 = calcSlope(p1[j],p1[j-1]);
							if (s1 != s2){
								curve.push({X:p2[geti2(count2)].X,Y:p2[geti2(count2)].Y});
							}
							i = j;
							break;
						}
					}
					if (converged){
						break;
					}
					// Add the vertex to curve since not yet aligned
					curve.push({X:p2[geti2(count2)].X,Y:p2[geti2(count2)].Y});
					count2++;
				}
				curves.push(curve);
			}
			count2 += 1;
		}
		return curves;
	}

}



module.exports = Layout



// WEBPACK FOOTER //
// ../calc/Layout.js